export default "<ion-label>{{ name }}</ion-label>";